import { call, put, takeLatest } from "redux-saga/effects";
import {
  doLoadingStart,
  doLoadingFinish,
} from "../../Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";

import * as actionTypes from "../../Redux/Actions/actionTypes";
import * as FileManagementActions from "../../Redux/Actions/FileManagementAction";
import FileDownloadRequest from "../../Communication/ApiClasses/FileDownloadRequest";
import FileDeleteRequest from "../../Communication/ApiClasses/FileDeleteRequest";
import FileStatsRequest from "../../Communication/ApiClasses/FileStatsRequest";

// File Download Saga
function* handleFileDownloadRequest(action) {
  yield put(doLoadingStart(`${actionTypes.FILE_DOWNLOAD_REQUEST}_SAGA`));

  const { fileId, callback } = action.payload;

  const fileDownloadApi = new FileDownloadRequest(fileId);

  try {
    const result = yield call(fileDownloadApi.getData.bind(fileDownloadApi));
    yield put(FileManagementActions.downloadFileSuccess(result));
    if (callback) {
      yield call(callback, result);
    }
  } catch (error) {
    yield put(FileManagementActions.downloadFileError(error.response || error));
    if (callback) {
      yield call(callback, error.response || error);
    }
  } finally {
    yield put(doLoadingFinish(`${actionTypes.FILE_DOWNLOAD_REQUEST}_SAGA`));
  }
}

// File Delete Saga
function* handleFileDeleteRequest(action) {
  yield put(doLoadingStart(`${actionTypes.FILE_DELETE_REQUEST}_SAGA`));

  const { fileId, callback } = action.payload;

  const fileDeleteApi = new FileDeleteRequest(fileId);

  try {
    const result = yield call(fileDeleteApi.getData.bind(fileDeleteApi));
    yield put(FileManagementActions.deleteFileSuccess(result));
    if (callback) {
      yield call(callback, result);
    }
  } catch (error) {
    yield put(FileManagementActions.deleteFileError(error.response || error));
    if (callback) {
      yield call(callback, error.response || error);
    }
  } finally {
    yield put(doLoadingFinish(`${actionTypes.FILE_DELETE_REQUEST}_SAGA`));
  }
}

// File Stats Saga
function* handleFileStatsRequest(action) {
  yield put(doLoadingStart(`${actionTypes.FILE_STATS_REQUEST}_SAGA`));

  const { callback } = action.payload;

  const fileStatsApi = new FileStatsRequest();

  try {
    const result = yield call(fileStatsApi.getData.bind(fileStatsApi));
    yield put(FileManagementActions.getFileStatsSuccess(result));
    if (callback) {
      yield call(callback, result);
    }
  } catch (error) {
    yield put(FileManagementActions.getFileStatsError(error.response || error));
    if (callback) {
      yield call(callback, error.response || error);
    }
  } finally {
    yield put(doLoadingFinish(`${actionTypes.FILE_STATS_REQUEST}_SAGA`));
  }
}

// Watchers
export function* fileDownloadWatcherSaga() {
  yield takeLatest(
    actionTypes.FILE_DOWNLOAD_REQUEST,
    handleFileDownloadRequest
  );
}

export function* fileDeleteWatcherSaga() {
  yield takeLatest(actionTypes.FILE_DELETE_REQUEST, handleFileDeleteRequest);
}

export function* fileStatsWatcherSaga() {
  yield takeLatest(actionTypes.FILE_STATS_REQUEST, handleFileStatsRequest);
}

export default function* fileManagementWatcherSaga() {
  yield takeLatest(
    actionTypes.FILE_DOWNLOAD_REQUEST,
    handleFileDownloadRequest
  );
  yield takeLatest(actionTypes.FILE_DELETE_REQUEST, handleFileDeleteRequest);
  yield takeLatest(actionTypes.FILE_STATS_REQUEST, handleFileStatsRequest);
}
